import React from "react";
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CButton,
  CAlert,
  CSpinner,
} from "@coreui/react";
import DocumentVerification from "../../models/document-verification";

interface DocumentVerificationDeleteModalProps {
  verification: DocumentVerification;
  onClose: () => void;
  onDelete: () => void;
  deleting?: boolean;
}

const DocumentVerificationDeleteModal: React.FC<
  DocumentVerificationDeleteModalProps
> = ({ verification, onClose, onDelete, deleting }) => {
  const handleDelete = () => {
    onDelete();
    onClose();
    deleting = false;
  };

  return (
    <CModal show={true} onClose={onClose} color="danger" centered>
      <CModalHeader closeButton>
        <CModalTitle>Eliminar Verificación de Documentos</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CAlert color="danger">
          <h4>¿Está seguro que desea eliminar esta verificación?</h4>
          <hr />
          <p>
            <strong>Número de Viaje:</strong> {verification.tripNumber || "N/A"}
          </p>
          <p>
            <strong>Usuario:</strong> {verification.username}
          </p>
          <p>
            <strong>Fecha:</strong>{" "}
            {new Date(verification.date).toLocaleString()}
          </p>
          <p>
            <strong>Área:</strong> {verification.area || "N/A"}
          </p>
          <p>
            <strong>Documentos verificados:</strong>{" "}
            {verification.items?.length || 0}
          </p>
          <hr />
          <p className="mb-0">
            <strong>Esta acción no se puede deshacer.</strong> Se eliminarán
            todos los datos relacionados con esta verificación.
          </p>
        </CAlert>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={onClose}>
          Cancelar
        </CButton>
        <CButton color="danger" onClick={handleDelete} disabled={deleting}>
          {deleting ? (
            <>
              <CSpinner size="sm" /> Eliminando...
            </>
          ) : (
            "Eliminar"
          )}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default DocumentVerificationDeleteModal;
